import { fetchData, postData } from "./apis";

const path = "/service";

export const getServiceExpenseVoucherDetailsApi  = (value) => {
  let endPoint = `${path}/get-service-expense-record-with-details`;
  return postData(endPoint, value);
};

export const getServiceExpenseVoucherApi = (value) => {
  let endPoint = `${path}/get-service-expense-voucher-no`;
  return postData(endPoint,value);
};

export const getServiceRecordWithDetailsApi = (value) => {
  let endPoint = `${path}/get-service-record-with-details`;
  return postData(endPoint, value);
};

export const serviceExpenseDeleteApi = (value) => {
  let endPoint = `${path}/service-expense-delete`;
  return postData(endPoint, value);
};

export const ServiceVoucherApi = (value) => {
  let endPoint = `${path}/service-vouchers`;
  return postData(endPoint, value);
};

export const serviceExpenceVoucherApi = (value) => {
  let endPoint = `${path}/service-expense-vouchers`;
  return postData(endPoint, value);
};

export const getServiceVoucherNoApi = (value) => {
  let endPoint = `${path}/get-service-voucher-no`;
  return postData(endPoint,value);
};

export const serviceDeleteApi = (value) => {
  let endPoint = `${path}/service-delete`;
  return  postData(endPoint,value);
};

// ---------------- Service Return ----------------
export const getServiceReturnVoucherNoApi = (value) =>
  postData(`${path}/get-service-return-voucher-no`, value);

export const getReturnableServiceVouchersApi = (value) =>
  postData(`${path}/service-return-returnable-vouchers`, value);

export const getServiceReturnableDetailsApi = (value) =>
  postData(`${path}/get-service-returnable-details`, value);

export const createServiceReturnApi = (value) =>
  postData(`${path}/create-service-return`, value);

export const getServiceReturnRecordApi = (value) =>
  postData(`${path}/get-service-return-record`, value);

export const getServiceReturnDetailsApi = (value) =>
  postData(`${path}/get-service-return-details`, value);

export const getServiceReturnVouchersApi = (value) =>
  postData(`${path}/service-return-vouchers`, value);

export const deleteServiceReturnApi = (value) =>
  postData(`${path}/service-return-delete`, value);

